// @flow

import type { ReasonSpecificScriptsState } from "./types";

export const initialState: ReasonSpecificScriptsState = {
  requestsInProgress: 0,
  list: null,
  schema: {
    type: "object",
    required: ["scriptName", "clientAbsenceReasons", "scriptText", "isActive"],
    properties: {
      scriptName: {
        type: "string",
        title: "Script Name",
        max_length: 300,
      },
      clientAbsenceReasons: {
        type: "array",
        required: ["id"],
        title: "Absence Reason",
        minItems: 1,
        uniqueItems: true,
        items: {
          type: "object",
          required: ["id"],
          properties: {
            id: {
              type: "integer",
              title: "Absence Reason",
              oneOf: [
                {
                  const: 250,
                  title: "Accidents and/or Injury",
                },
                {
                  const: 294,
                  title: "Adverse weather",
                },
              ],
            },
          },
        },
      },
      scriptText: {
        type: "string",
        title: "Script text",
        max_length: 300,
      },
      isActive: {
        type: "boolean",
        title: "Is Active",
      },
    },
  },
  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  modals: {
    showAddReasonSpecificScriptModal: false,
    modalStep: 1,
    showEditModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showDiscardModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
    showEditAssignmentsModal: false,
  },
};

export default initialState;
